import { useLanguage } from "../context/LanguageContext";
import { GraduationCap } from "lucide-react";

const EducationSection = ({ education }) => {
  const { language, t } = useLanguage();

  const getLocalizedText = (field) => {
    if (typeof field === 'string') return field;
    return language === 'no' ? field.no : field.en;
  };

  return (
    <section data-testid="education-section" className="py-16 md:py-24 border-t border-slate-200">
      <h2 className="text-3xl md:text-4xl font-semibold tracking-tight text-slate-800 mb-12 animate-fade-in-up">
        {t('Utdanning', 'Education')}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {education.map((edu, index) => (
          <div
            key={index}
            data-testid={`education-item-${index}`}
            className="bg-white border border-slate-200 rounded-lg p-6 hover:border-sky-400 hover:shadow-md transition-all duration-300 animate-fade-in-up"
            style={{ animationDelay: `${(index + 1) * 100}ms` }}
          >
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-lg bg-slate-100 flex items-center justify-center flex-shrink-0">
                <GraduationCap className="w-5 h-5 text-slate-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-900 mb-1">
                  {getLocalizedText(edu.degree)}
                </h3>
                <p className="text-slate-600 text-sm mb-2">
                  {getLocalizedText(edu.institution)}
                </p>
                <p className="text-sky-600 text-sm font-medium">
                  {edu.dates}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default EducationSection;
